import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export function DialogBox(props) {
  const { title, content, openDialog, closeDialog, mainAction } = props;
  return (
    <Dialog
      open={openDialog}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      style={{ zIndex: 1000000 }}
    >
      <DialogTitle>
        <Typography variant="h2">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="secondary" onClick={closeDialog}>
          Não
        </Button>
        <Button variant="text" color="secondary" onClick={mainAction}>
          Sim
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DialogBox.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  openDialog: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  mainAction: PropTypes.func.isRequired,
};
